import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/60">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-semibold text-foreground-950">
                Sugargoo<span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
              The most comprehensive Sugargoo Spreadsheet resource platform. Helping international shoppers discover the best products, compare prices, and shop smarter since 2024.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Complete Guide</Link>
              </li>
              <li>
                <Link to="/sugargoo-shipping-cost" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Shipping Cost</Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Coupons & Deals</Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Warehouse Guide</Link>
              </li>
              <li>
                <Link to="/is-sugargoo-legit" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">Is Sugargoo Legit?</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-300/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              Main Platform
            </a>
            <Link to="/sugargoo-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}